<template>
  <div class="handle-container">
    <Header title="服务办理" :employId="query.employId" />
    <div class="handle-inner">
      <!-- <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="query.hall" :to="{ path: '/hall' }">办事大厅</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: `guide?employId=${query.employId}&hall=${query.hall}` }">办理指南</el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-form label-width="120px">
        <el-form-item v-for="item in itemList" :key="item.fieldName" :label="item.type === 10 ? '' : item.fieldTitle"
          :style="{ width: widthList[item.proportion - 1], '--color': item.isRequired ? 'red' : 'transparent' }">
          <!-- 单行文本 -->
          <el-input v-model="item.value" :maxlength="item.limitation" show-word-limit :placeholder="item.fieldReminder"
            clearable v-if="item.type === 1"></el-input>
          <!-- 地址选择 -->
          <el-cascader v-model="item.value" :options="regionTree"
            :props="{ value: 'regionId', label: 'name', children: 'childrenList' }" :placeholder="item.fieldReminder"
            v-if="item.type === 2"></el-cascader>
          <!-- 下拉选择 / 字典-->
          <el-select v-model="item.value" v-if="[3, 8].includes(item.type)" :multiple="item.fieldType === 1"
            :placeholder="item.fieldReminder">
            <el-option v-for="{ optionValue } in item.optionList" :key="optionValue" :label="optionValue"
              :value="optionValue"></el-option>
          </el-select>
          <!-- 时间选择:年-->
          <el-date-picker v-model="item.value" type="year" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 0"></el-date-picker>
          <!-- 时间选择:年月-->
          <el-date-picker v-model="item.value" type="month" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 1"></el-date-picker>
          <!-- 时间选择:年月日-->
          <el-date-picker v-model="item.value" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :placeholder="item.fieldReminder" v-if="item.type === 4 && item.fieldType === 2"></el-date-picker>
          <!-- 时间选择:年月日 时分-->
          <el-date-picker v-model="item.value" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
            :placeholder="item.fieldReminder" v-if="item.type === 4 && item.fieldType === 3"></el-date-picker>
          <!-- 时间选择:时分-->
          <el-time-picker v-model="item.value" format="HH:mm" value-format="HH:mm" :placeholder="item.fieldReminder"
            v-if="item.type === 4 && item.fieldType === 4"></el-time-picker>
          <!-- 文本域 -->
          <el-input type="textarea" v-model="item.value" :maxlength="item.limitation" show-word-limit :rows="1"
            :placeholder="item.fieldReminder" v-if="item.type === 5"></el-input>
          <!-- 单选框-->
          <el-radio-group v-model="item.value" v-if="item.type === 6 && item.fieldType === 0">
            <el-radio v-for="{ optionValue } in item.optionList" :key="optionValue" :label="optionValue"></el-radio>
          </el-radio-group>
          <!-- 多选框 -->
          <el-checkbox-group v-model="item.value" v-if="item.type === 6 && item.fieldType === 1"
            :placeholder="item.fieldReminder">
            <el-checkbox v-for="{ optionValue } in item.optionList" :key="optionValue"
              :label="optionValue"></el-checkbox>
          </el-checkbox-group>
          <!-- 附件 -->
          <el-upload action="#" :file-list="item.value" :before-upload="(file) => { beforeUpload(file, item) }"
            :http-request="(options) => { customUpload(options, item) }"
            :on-success="(res, file, fileList) => { onSuccess(res, file, fileList, item) }"
            :on-remove="(_, fileList) => { removeFile(fileList, item) }" :limit="item.uploadNumber"
            :list-type="item.type === 9 ? 'picture' : ''" v-if="[7, 9].includes(item.type)">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="placeholder">{{ item.fieldReminder }}</div>
          </el-upload>
          <!-- 部门 -->
          <el-cascader v-if="item.type === 11" v-model="item.value" :options="item.optionList" :props="{
            multiple: item.fieldType == 1, checkStrictly: false, value: 'id',
            label: 'name',
            children: 'childrenList',
          }" :placeholder="item.fieldReminder"></el-cascader>
          <!-- 职位 -->
          <el-cascader v-if="item.type === 12" v-model="item.value" :options="item.optionList" :props="{
            multiple: item.fieldType == 1, checkStrictly: false, value: 'id',
            label: 'name',
            children: 'childrenList',
          }" :placeholder="item.fieldReminder"></el-cascader>
          <!-- 分割线 -->
          <el-divider :content-position="['left', 'center', 'right'][item.fieldType]" v-if="item.type === 10">{{
            item.fieldTitle }}</el-divider>
        </el-form-item>
      </el-form>
      <div class="bottom">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button type="info" @click="$router.back()">取消</el-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import * as api from "./api"
import md5 from '@/utils/md5'
import { getDepartmentListApi, getUserInfo } from "@/modules/customForm/pages/api"
import { getAllPositionsApi, getUserPositionApi } from "@/components/api.js"
export default {
  name: "Handle",
  components: {
    Header: () => import("../../components/Header"),
    Footer: () => import("../../components/Footer"),
  },
  data() {
    return {
      query: {},
      itemList: [],
      widthList: ["25%", "50%", "75%", "100%"],
      regionTree: [],
    }
  },
  async created() {
    this.query = this.$route.query
    const { data: { formInfo: { fieldList } } } = await api.getFormItem(this.query.formId)
    this.itemList = fieldList.map((item, index) => {
      if (item.type == 11) {
        switch (true) {
          case item.getValueMethod == 2:
            // 自动过滤场景
            this.getUserInfo("echo", index)
            break

          case item.optionRange == 1:
            // 全部数据场景
            this.getDepartmentList("echo", index)
            break

          case item.optionRange == 3:
            // 账号自动过滤
            this.getUserInfo("echo", index)
            break

          case item.optionRange == 2:
            // 手动选择场景
            this.getDepartmentList("echoHandle", index)
            break

          default:
            // 默认情况不做处理
            break
        }

        // 直接返回，避免继续执行后面的逻辑
        return {
          ...item,
          format: item.type === 9 ? JSON.parse(item.format) : item.format,
          value:
            ([3, 6, 8].includes(item.type) && item.fieldType) ||
              [7, 9].includes(item.type)
              ? []
              : "",
        }
      }
      if (item.type == 12) {
        switch (true) {
          case item.getValueMethod == 2:
            // 自动过滤场景
            this.getUserPositionList("echo", index)
            break

          case item.optionRange == 1:
            // 全部数据场景
            this.getPositionList("echo", index)
            break

          // case item.optionRange == 3:
          //   // 账号自动过滤
          //   this.getUserPositionList("echo", index)
          //   break

          case item.optionRange == 2:
            // 手动选择场景
            this.getPositionList("echoHandle", index)
            break

          default:
            // 默认情况不做处理
            break
        }

        // 直接返回，避免继续执行后面的逻辑
        return {
          ...item,
          format: item.type === 9 ? JSON.parse(item.format) : item.format,
          value:
            ([3, 6, 8].includes(item.type) && item.fieldType) ||
              [7, 9].includes(item.type)
              ? []
              : "",
        }
      }
      return {
        ...item,
        format: item.type === 9 ? JSON.parse(item.format) : item.format,
        value:
          ([3, 6, 8].includes(item.type) && item.fieldType) ||
            [7, 9].includes(item.type)
            ? []
            : "",
      }
    })
    // 省市区
    const {
      data: { regionList },
    } = await api.getRegionTree()
    this.regionTree = regionList
  },
  methods: {
    beforeUpload(file, item) {
      if (item.uploadNumber && item.value.length >= item.uploadNumber) {
        this.$message.warning('文件数量不能超过 ' + item.uploadNumber + ' 个')
        return item.withoutUpload = true
      }
      if (item.limitation && file.size / 1024 / 1024 > item.limitation) {
        this.$message.warning('文件大小不能超过 ' + item.limitation + 'MB')
        return item.withoutUpload = true
      }
      if (item.format) {
        // const format = JSON.parse(item.format)
        if (!item.format.includes(file.type)) {
          this.$message.warning('文件格式仅支持 ' + item.format.map(i => i.split('/')[1]).join('、'))
          return item.withoutUpload = true
        }
      }
    },
    async customUpload(options, item) {
      const { file } = options
      let formData = new FormData()
      formData.append("file", file)
      formData.append("code", md5(file.size))
      let { data } = await api.uploadApi(formData)
      item.value.push({
        name: data.filePath,
        url: localStorage.getItem('baseUrl') + data.filePath
      })
    },
    onSuccess(res, file, fileList, item) {
      // if (item.withoutUpload) {
      //   fileList.splice(- 1, 1)
      // } else {
      //   item.value.push({
      //     name: file.name,
      //     url: localStorage.getItem('baseUrl') + res.data.filePath
      //   })
      // }
      // item.withoutUpload = false
    },
    removeFile(fileList, item) {
      item.value = fileList
    },
    // 根据用户权限获取职位
    async getUserPositionList(type, index) {
      let id = JSON.parse(localStorage.getItem("userInfo")).id
      const {
        data: { positionList },
      } = await getUserPositionApi(id)
      if (type && type == "echo") {
        //弹窗打开回显
        this.itemList[index].optionList = positionList
      }
    },
    // 获取全部职位列表
    async getPositionList(type, index) {
      const {
        data: { positionList },
      } = await getAllPositionsApi()
      if (type && type == "echo") {
        //编辑回显设置下拉选项
        this.itemList[index].optionList = positionList
      } else if (type && type == "echoHandle") {
        this.positionList = positionList
        //编辑回显为手动设置接口返回为平级的数组-----修改为树形的下拉选项内容
        // this.itemList[index].oldOptionList = this.itemList[index].optionList
        this.itemList[index].optionList = JSON.parse(
          this.itemList[index].extra
        );
      }
    },
    // 根据用户权限获取部门
    async getUserInfo(type, index) {
      let id = JSON.parse(localStorage.getItem("userInfo")).id
      const {
        data: { departmentList },
      } = await getUserInfo(id)
      if (type && type == "echo") {
        //弹窗打开回显
        this.itemList[index].optionList = departmentList
      }
    },
    // 获取全部部门列表
    async getDepartmentList(type, index) {
      const {
        data: { departmentList },
      } = await getDepartmentListApi()
      if (type && type == "echo") {
        //编辑回显设置下拉选项
        this.itemList[index].optionList =
          this.filterEmptyChildren(departmentList)
      } else if (type && type == "echoHandle") {
        this.departmentList = this.filterEmptyChildren(departmentList)
        //编辑回显为手动设置接口返回为平级的数组-----修改为树形的下拉选项内容
        this.itemList[index].oldOptionList = this.itemList[index].optionList
        let data = this.handleDepartmentCheck(
          this.itemList[index].optionList,
          this.departmentList
        )
        this.itemList[index].optionList = this.filterEmptyChildren(data)
      }
    },

    //编辑回显为手动设置接口返回为平级的数组-----修改为树形的下拉选项内容
    handleDepartmentCheck(optionList, departmentList) {
      // 1. 从optionList建立optionValue到对象的映射
      const optionValueMap = {}
      optionList.forEach((option) => {
        optionValueMap[option.optionValue] = option
      })

      // 2. 收集需要勾选的节点ID和半选的父节点ID
      const checkedIds = new Set() // 使用Set避免重复
      const halfCheckedIds = new Set()

      // 3. 递归遍历部门树，筛选并保留匹配节点及父级链
      function traverseAndFilter(nodes, parent = null) {
        return nodes
          .map((node) => {
            // 深拷贝节点
            const clonedNode = { ...node, childrenList: [] }

            // 递归处理子节点
            if (node.childrenList && node.childrenList.length > 0) {
              clonedNode.childrenList = traverseAndFilter(
                node.childrenList,
                clonedNode
              )
            }

            // 检查匹配状态
            const isMatched = !!optionValueMap[node.id]
            const hasMatchedChildren = clonedNode.childrenList.length > 0

            if (isMatched) {
              // 填充字段并记录勾选ID
              clonedNode.fieldId = optionValueMap[node.id].fieldId
              clonedNode.optionId = optionValueMap[node.id].optionId
              clonedNode.optionValue = optionValueMap[node.id].optionValue
              checkedIds.add(node.id)

              // 标记所有父级为半选
              let current = parent
              while (current) {
                if (!checkedIds.has(current.id)) {
                  halfCheckedIds.add(current.id)
                }
                current = current.parent
              }
              return clonedNode
            } else if (hasMatchedChildren) {
              // 子节点有匹配，保留当前父节点（但不填充字段）
              halfCheckedIds.add(node.id) // 标记为半选
              return clonedNode
            } else {
              return null
            }
          })
          .filter(Boolean)
      }

      // 执行筛选
      const filteredDepartmentList = traverseAndFilter(departmentList)

      // 4. 设置树组件勾选状态（包括半选状态）
      this.$nextTick(() => {
        const tree = this.$refs.departmentTree
        if (tree) {
          tree.setCheckedKeys(Array.from(checkedIds))
          // 手动设置半选状态（Element UI 2.x需要此操作）
          halfCheckedIds.forEach((id) => {
            const node = tree.getNode(id)
            if (node) {
              node.indeterminate = true
            }
          })
        }
      })

      return filteredDepartmentList
    },
    // 取消为[]的子级
    filterEmptyChildren(nodes) {
      return nodes.filter((node) => {
        // 先递归处理子节点
        if (node.childrenList && node.childrenList.length > 0) {
          node.childrenList = this.filterEmptyChildren(node.childrenList)
          // 处理后如果子节点不为空，则保留该节点
          if (node.childrenList.length > 0) {
            return true
          }
        }
        // 完全删除 childrenList 字段（包括空数组）
        delete node.childrenList
        return true // 保留当前节点
      })
    },
    submit() {
      // 表单项必填检验
      const requiredItem = this.itemList.filter((item) => item.isRequired)
      if (
        requiredItem.length &&
        requiredItem.find((item) => item.value === "" || !item.value.length)
      )
        return this.$message.warning("请完善必填项")

      const newList = this.itemList.map((item) => {
        // 非类型11的项直接浅拷贝返回
        if (item.type !== 11) {
          return { ...item }
        }

        // 处理类型11的项
        let value
        if (item.fieldType === 0) {
          // fieldType为0时，用数组包裹value
          value = item.value ? [item.value] : ""
        } else if (item.fieldType === 1) {
          // fieldType为1时，直接使用value
          value = item.value ? item.value : ""
        } else {
          // 其他fieldType情况保持原value不变
          value = item.value
        }

        return { ...item, value }
      })
      api.appleService({
        employId: this.query.employId,
        deployId: this.query.deployId,
        formData: {
          formId: this.query.formId,
          detailList: newList.map((item) => {
            return {
              fieldId: item.fieldId,
              fieldName: item.fieldName,
              fieldValue: [11].includes(item.type) // 先判断是否为类型11
                ? item.value === ""
                  ? undefined // 类型11且value为空或不存在时，不设置该字段
                  : JSON.stringify(item.value) // 类型11且value有效时，返回原始值的JSON字符串
                : Array.isArray(item.value) // 其他类型再判断是否为数组
                  ? [7, 9].includes(item.type)
                    ? item.value.map((i) => i.name).join()
                    : item.value.join()
                  : item.value,
            }
          }),
        },
      })
      this.$message.success("提交成功")
      this.$router.push(`/guide?employId=${this.query.employId}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.handle-container {
  .handle-inner {
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 120px 0 50px;
    display: flex;
    flex-direction: column;
    position: relative;

    ::v-deep.el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      &-item {
        display: flex;
        margin: 0;
        width: 100%;
        border: 1px dashed transparent;
        padding: 10px;
        position: relative;
        display: flex;
        align-items: center;

        &__label {
          line-height: 24px;

          &::before {
            content: "*";
            color: var(--color);
            margin-right: 5px;
          }
        }

        &__content {
          width: 0;
          flex: 1;
          margin-left: 0 !important;

          .el-select,
          .el-cascader,
          .el-input {
            width: 100%;
          }

          .el-radio-group {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 15px 20px;

            .el-radio {
              margin: 0;
            }
          }

          .el-checkbox-group {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 0 20px;
          }

          .placeholder {
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
    }

    .bottom {
      align-self: center;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;

      .el-button {
        width: 120px;
      }
    }
  }
}
</style>